const events = [
    'animationstart',
    'webkitAnimationStart',
    'animationiteration',
    'webkitAnimationIteration',
    'animationend',
    'webkitAnimationEnd',
    'input',
    'mouseup',
    'mousedown',
    'orientationchange',
    'afterprint',
    'beforeprint',
    'readystatechange',
    'touchstart',
    'touchend',
    'touchcancel',
    'transitionstart',
    'webkitTransitionStart',
    'MSTransitionStart',
    'oTransitionStart',
    'otransitionstart',
    'transitioniteration',
    'webkitTransitionIteration',
    'MSTransitionIteration',
    'oTransitionIteration',
    'otransitioniteration',
    'transitionend',
    'webkitTransitionEnd',
    'MSTransitionEnd',
    'oTransitionEnd',
    'otransitionend',
    'resize',
];

export const setupEventListeners = (callback: () => void) => {
    const cleanup = events.map(eventName => {
        window.addEventListener(eventName, callback, false);
        return () => window.removeEventListener(eventName, callback, false);
    });

    return () => cleanup.forEach(c => c());
};
